import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { IDNParser } from '../helpers/idn.helpers';


class DashboardForm extends Component {
  state = {
    queryText: '',
    querySubmitted: '',
    validationError: false,
  };

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (e) => {
    const query = e.target.value;
    this.setState((prevState) => ({
      ...prevState,
      queryText: query,
    }));
  };

  handleFormSubmit = (e) => {
    e.preventDefault();
    const searchedText = this.state.queryText.trim();

    this.setState({
      validationError: false,
      querySubmitted: searchedText,
    });

    this.props.onSubmitDashboardForm(IDNParser.parseOrderListSearchTextToUtf8(searchedText));
  };

  render() {
    const error =
      (this.props.bundleListError &&
        this.state.queryText === this.state.querySubmitted &&
        !this.props.isBundleListLoading) ||
      this.state.validationError;

    return (
      <form
        name="formDiv"
        id="formDiv"
        className="dashboard-form"
        onSubmit={this.handleFormSubmit}
      >
        <label className="dashboard-label input-label">
          <FormattedMessage id="order-info-help-text" />
        </label>
        <div>
          <input
            name="domainName"
            type="text"
            className={`dashboard-input input ${error ? 'input-error' : ''}`}
            placeholder="abc@example.com / example.com"
            autoFocus
            onChange={this.handleChange}
            value={this.state.queryText}
          />
          <div className="error dashboard-error">
            {this.state.validationError ? (
              <FormattedMessage id="search-field-validation-error" />
            ) : (
              this.props.bundleListError
            )}
          </div>
        </div>
        <button
          type="primary"
          className="button button-primary dashboard-button"
          name="btndashBoard"
          disabled={this.props.isBundleListLoading}
        >
          <FormattedMessage id="order-info-button-text" />
        </button>
      </form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isBundleListLoading: state.orders.isBundleListLoading,
    bundleListError: state.orders.bundleListError,
  };
};

export default connect(mapStateToProps)(DashboardForm);
